import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_EXPENSE_CATEGORIES_OF_TYPE } from "../graphql/expenseCategory";
import { MappedCategories } from "../components/admin/integration/MapYourCategoriesDrawer";
import ExpenseCategoryType from "../enums/ExpenseCategoryType";

export const useCategories = () => {
  const { data: categories, refetch: refetchOutpaveCategories } = useQuery(
    GET_EXPENSE_CATEGORIES_OF_TYPE,
    {
      variables: { type: ExpenseCategoryType.OUTPAVE },
    },
  );
  const [outpaveCategories, setOutpaveCategories] = useState<
    MappedCategories[]
  >([]);

  useEffect(() => {
    if (categories) {
      setOutpaveCategories(categories.expenseCategories);
    }
  }, [categories]);

  return { refetchOutpaveCategories, outpaveCategories };
};
